var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMessageIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.669 2.08255L16.669 2.08256C18.1499 2.79603 19.4505 3.83453 20.4739 5.1206L20.474 5.12066C21.4976 6.40674 22.2176 7.90729 22.5806 9.51048C22.9434 11.1136 22.9397 12.778 22.5699 14.3795C22.2 15.981 21.4734 17.4785 20.4443 18.7601C19.4152 20.0417 18.11 21.0745 16.626 21.7816C15.1421 22.4886 13.5178 22.8515 11.8742 22.8434C10.3178 22.8357 8.78206 22.4955 7.36955 21.8466L7.08373 21.7153L6.77421 21.7713L1.07941 22.801L2.69547 18.5014L2.86741 18.0439L2.61212 17.6272C1.65346 16.0623 1.10338 14.279 1.01583 12.4416C0.921808 10.4682 1.3648 8.50629 2.29762 6.7648C3.23044 5.0233 4.61816 3.56744 6.31297 2.55225C8.00769 1.53713 9.94629 1.00066 11.9218 1L11.9221 1C13.5657 0.999066 15.1883 1.36911 16.669 2.08255ZM0.990884 23.0365L0.990947 23.0364L0.990884 23.0365Z",
    fill: "white",
    fillOpacity: 0.5,
    stroke: "white",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessageIcon);
export default __webpack_public_path__ + "static/media/messageIcon.84bd1269185fc006043573720e2c2d09.svg";
export { ForwardRef as ReactComponent };